import { colors } from '../../constants/colors';
export const styles = {
  downloadButton:{
    zIndex:2,
    height:40,
    width:150,
    color: "white",
    fontSize: 12,
    borderStyle: "none",
    width: "100%",
    maxWidth: "150px",
    backgroundColor: colors.button_orange,
  },
  logoContainer:{
    position: "absolute",
    zIndex: 3,
    top: 20,
    left: "5%",
  },
  selectButton: {
    borderRadius: '5px',
    border: '1px solid #ccc',
    backgroundColor: colors.dark_blue,
    color: colors.white,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 0.3s ease',
    fontFamily: 'Irish Grover',
    fontWeight: 'bold',
    textAlign: 'center',
    width: 150,
    height: 40,
    fontSize: 18,
  },
}